(function () {
  'use strict';
  if (window.aonaCart) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function nativeCheckoutUrl() {
    var url = root + 'checkout';
    try { var code = sessionStorage.getItem('aona_applied_coupon'); if (code) url += '?discount=' + encodeURIComponent(code); } catch (_) {}
    return url;
  }
  function authenticated() {
    return typeof window.aonaIsUserAuthenticated === 'function' && window.aonaIsUserAuthenticated();
  }
  function checkoutUrl() {
    var destination = nativeCheckoutUrl();
    return authenticated() ? destination : root + 'account/login?checkout_url=' + encodeURIComponent(destination);
  }
  async function waitForAuth() {
    if (window.aonaCustomerLoggedIn === true) return;
    var deadline = Date.now() + 4000;
    while (!(window.aonaFirebase && window.aonaFirebase.auth) && Date.now() < deadline) {
      await new Promise(function(resolve) { setTimeout(resolve, 50); });
    }
    var auth = window.aonaFirebase && window.aonaFirebase.auth;
    if (auth && typeof auth.authStateReady === 'function') {
      await Promise.race([auth.authStateReady(), new Promise(function(resolve) { setTimeout(resolve, Math.max(0, deadline - Date.now())); })]);
    }
  }
  var checkingOut = false;
  async function checkout() {
    if (checkingOut) return false;
    checkingOut = true;
    try { await waitForAuth(); window.location.assign(checkoutUrl()); return true; }
    catch (_) { notice('Unable to confirm your sign-in. Please sign in and try checkout again.', true); return false; }
    finally { checkingOut = false; }
  }
  var running = new WeakSet();
  function notice(message, error, anchor) {
    var box = document.getElementById('aona-cart-feedback');
    if (!box) { box = document.createElement('div'); box.id = 'aona-cart-feedback'; document.body.appendChild(box); }
    box.setAttribute('role', error ? 'alert' : 'status');
    box.className = error ? 'aona-cart-feedback is-error' : 'aona-cart-feedback';
    box.replaceChildren(document.createTextNode(message));
    if (!error) { var link = document.createElement('a'); link.href = root + 'cart'; link.textContent = 'View cart'; box.appendChild(link); }
    if (anchor && anchor.closest('#aona-qv')) anchor.closest('#aona-qv').appendChild(box);
    else document.body.appendChild(box);
  }
  async function add(id, quantity, buyNow, button, form) {
    if (button && running.has(button)) return false;
    if (form && typeof form.reportValidity === 'function' && !form.reportValidity()) return false;
    quantity = Number(quantity == null ? 1 : quantity);
    if (!/^\d+$/.test(String(id || '')) || !Number.isInteger(quantity) || quantity < 1) { notice('Choose an available variant and a valid quantity.', true, button); return false; }
    if (button) { running.add(button); button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    try {
      var payload = form ? new FormData(form) : new FormData();
      payload.set('id', String(id)); payload.set('quantity', String(quantity));
      // Form item properties and selling plans remain intact; Shopify validates stock.
      var response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: payload });
      var item;
      try { item = await response.json(); } catch (_) { throw new Error('Unable to add this item. Please try again.'); }
      if (!response.ok || item.status >= 400) throw new Error(item.description || item.message || 'This item could not be added. Please try again.');
      if (buyNow) { return await checkout(); }
      var cart = null;
      try { var cartResponse = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }); if (cartResponse.ok) cart = await cartResponse.json(); } catch (_) {}
      if (cart) document.querySelectorAll('.aona-header-cart-count,.cart-count,#aona-cart-count-badge,[data-cart-count],.cart-count-badge,.cart-count-bubble-sticky').forEach(function(node) { node.textContent = cart.item_count; node.style.display = cart.item_count > 0 ? '' : 'none'; });
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
      notice('Added to your cart.', false, button);
      return true;
    } catch (error) { notice(error instanceof TypeError ? 'Unable to connect. Check your connection and try again.' : (error.message || 'Unable to add this item. Please try again.'), true, button); return false; }
    finally { if (button) { running.delete(button); button.disabled = false; button.removeAttribute('aria-busy'); } }
  }
  var buySelector = '#aona-qv-buynow,.vessel-btn-buynow,.stitch-btn-buynow,.aona-pdp-btn-secondary,.aona-mob-btn-secondary,[data-buy-now],.instant-checkout-btn,[data-instant-checkout]';
  var checkoutSelector = 'button[name="checkout"],#checkout,.cart__checkout-button,#aona-main-checkout-btn,button.aona-razorpay-pay-btn,a[href^="/checkout"],.magic-checkout-btn,[data-magic-checkout],.rzp-magic-checkout-btn';
  var addSelector = '#vessel-ms-atc,.vessel-ms-atc-btn,#aona-qv-atc,.vessel-btn-atc,#vessel-submit-atc,.vessel-pair-add-btn,button[name="add"],.aona-pdp-btn-primary,.aona-pdp-ms-atc-btn,.aona-mob-btn-primary,.aona-pdp-sticky-atc-btn,.product-form__submit,[data-add-to-cart],.aona-card-btn-atc,#stitch-atc-button,[data-action="add-to-cart"],.btn-add-to-cart,[data-button-quick-view="add-to-cart"]';
  function selection(button) {
    var form = button.form || button.closest('form');
    if (!form && button.dataset.variantId) return { id: button.dataset.variantId, quantity: button.dataset.quantity || 1, form: null };
    if (!form || !form.querySelector('[name="id"]')) form = document.getElementById('vessel-atc-form') || document.getElementById('aona-pdp-add-form') || document.getElementById('aona-pdp-form') || document.getElementById('aona-mob-add-form') || document.querySelector('form[action*="/cart/add"]');
    var id = button.dataset.variantId || (form && form.querySelector('[name="id"]') && form.querySelector('[name="id"]').value);
    var quantity = (form && form.querySelector('[name="quantity"]') && form.querySelector('[name="quantity"]').value) || 1;
    if (button.id === 'aona-qv-atc' || button.id === 'aona-qv-buynow') { id = document.getElementById('aona-qv-variant-id').value; quantity = document.getElementById('aona-qv-qty-val').textContent; form = null; }
    return { id: id, quantity: quantity, form: form };
  }
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var button = event.target.closest([buySelector, checkoutSelector, addSelector].join(','));
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (button.matches(checkoutSelector) && !button.matches(buySelector)) { checkout(); return; }
    var item = selection(button); add(item.id, item.quantity, button.matches(buySelector), button, item.form);
  }, true);
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (form instanceof HTMLFormElement && /\/cart\/?$/.test(new URL(form.action, location.href).pathname) && event.submitter && event.submitter.matches(checkoutSelector)) {
      event.preventDefault(); event.stopImmediatePropagation(); checkout(); return;
    }
    if (!(form instanceof HTMLFormElement) || !/\/cart\/add(?:\.[a-z]+)?\/?$/.test(new URL(form.action, location.href).pathname)) return;
    event.preventDefault(); event.stopImmediatePropagation();
    var button = event.submitter;
    var id = form.querySelector('[name="id"]'); var quantity = form.querySelector('[name="quantity"]');
    add(id && id.value, quantity ? quantity.value : 1, button && button.matches(buySelector), button, form);
  }, true);
  window.aonaCart = { add: add, checkout: checkout, checkoutUrl: checkoutUrl, waitForAuth: waitForAuth };
  try { Object.defineProperty(window, 'RazorpayMagicCheckout', { configurable:true, get:function() { return { open:checkout }; }, set:function() {} }); } catch (_) {}
})();
